import { useQuery } from '@tanstack/react-query';
import { getPortfolios } from '@simplywallst/services';

export const QUERY_KEY = ['PUBLIC_PORTFOLIOS'];

export const queryFn = async () => {
  const { data } = await getPortfolios({
    isPublic: true,
    include: ['items'],
  });
  return data.data.map((n) => ({
    id: n.id,
    name: n.name,
    dateGenerated: n.date_generated,
    currencyISO: n.currency_iso,
  }));
};

export const usePublicPortfolios = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn,
    retry: false,
    staleTime: Infinity,
  });
};
